import { render, staticRenderFns } from "./AddFcPackingAgent.vue?vue&type=template&id=538ee86e"
import script from "./AddFcPackingAgent.vue?vue&type=script&lang=js"
export * from "./AddFcPackingAgent.vue?vue&type=script&lang=js"
import style0 from "./AddFcPackingAgent.vue?vue&type=style&index=0&id=538ee86e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports